import { useCallback, useState } from 'react';

import { httpPost } from '../../../../components/utils';
import { ReportSettings } from '../types/RiskReport';

const useSaveRiskReportSettings = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [error, setError] = useState<string>();

    const triggerSaveRiskReportSettings = useCallback(async (settings: ReportSettings, onSuccess?: () => void) => {
        setIsLoading(true);
        setIsSuccessful(false);
        setError(undefined);

        try {
            await httpPost('/insights/saveRiskReportSettings', settings);
            if (onSuccess) {
                onSuccess();
            }
            setIsSuccessful(true);
        } catch (err) {
            setError('Failed to save risk report settings');
        }
        setIsLoading(false);
    }, []);

    return { mutate: triggerSaveRiskReportSettings, isLoading, isSuccessful, error };
};

export default useSaveRiskReportSettings;
